import { createAsyncThunk } from "@reduxjs/toolkit";
import { StoreState } from "../../../store/store.interface";
import { ActionStatus } from "../../../common/constants/action-status";
import { CreateWishListRequest } from "../interfaces/wish-list-actions.interface";
import { createWishListApiCallMagento } from "../apis/wish-list-create.api";

export const addWishList = createAsyncThunk('wishList/create', async (requestBody: CreateWishListRequest) => {
  return await createWishListApiCallMagento(requestBody);
}, {
  condition: ((_arg, {getState} )=>{
    const state = getState() as StoreState;
    return state.wishListState.createWishList.status !== ActionStatus.loading;
  })
});